export function  getUserId() {
  return sessionStorage.getItem("userid");
}
export function  getToken() {
  return sessionStorage.getItem("token");
}



// WEBPACK FOOTER //
// ./src/utils/auth.js